import { convertArrayToCamelCase, convertToCamelCase } from '@skytech/utils'

import type {
  InjuryReport,
  InjuryReportExtended,
} from '@/modules/applications/injury-reports/types'
import { get, post } from '@/util/auth'

const injuryReportsResources = {
  get: async (injuryReportId: number) => {
    const injuryReports = await get<Record<string, unknown>>(
      `manager/injury-reports/${injuryReportId}`
    )
    const parsedData = convertToCamelCase(injuryReports)

    return parsedData as InjuryReportExtended
  },
  getList: async () => {
    const injuryReports = await get<Record<string, unknown>[]>('manager/injury-reports')
    const parsedReports = convertArrayToCamelCase(injuryReports)

    return parsedReports as InjuryReport[]
  },

  // Mutations
  setStatus: ({ injuryReportId, statusId }: { injuryReportId: number; statusId: number }) =>
    post(`manager/injury-reports/${injuryReportId}/status`, {
      statusId,
    }),
}

export default injuryReportsResources
